import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useRegisterRequestSms */
export type TypeRegisterRequestSmsParams = {
  /** 휴대전화 번호 */
  phoneNumber: string;
};

/** @category useRegisterRequestSms */
export type TypeRegisterRequestSmsResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 회원가입 > 인증번호 요청 api에 사용되는 커스텀 훅
 */
export const useRegisterRequestSms = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRegisterRequestSmsParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-sign-up';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestRegisterRequestSms = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRegisterRequestSmsParams;
    onSuccess?: (res: TypeRegisterRequestSmsResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestRegisterRequestSms;
};
